import { type FC } from 'react';

import { Text } from '../Text';
import { type InfoProps } from './Info.types';
import { InfoContent } from './InfoContent';

type Props = InfoProps & {
	title?: string;
};

export const Info: FC<Props> = ({ icon, text, title }) => (
	<InfoContent icon={icon}>
		<span title={title} className="contents">
			<Text size="small" color="subdued" className="whitespace-normal">
				{text}
			</Text>
		</span>
	</InfoContent>
);
